import React from 'react';
import { SocialProofBar } from './components/SocialProofBar';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Problem } from './components/Problem';
import { WhyItDidntWork } from './components/WhyItDidntWork';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { Testimonials } from './components/Testimonials';
import { ForWhom } from './components/ForWhom';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-[#FDFAF6] overflow-x-hidden" data-id="element-0">
      <SocialProofBar data-id="element-1" />
      <Nav data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <TrustBar data-id="element-5" />
        <Problem data-id="element-6" />
        <WhyItDidntWork data-id="element-7" />
        <Mechanism data-id="element-8" />
        <WhatYouGet data-id="element-9" />
        <Testimonials data-id="element-10" />
        <ForWhom data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}